/** @format */

import { apiInstanceFetch } from "../../../util/api";
import * as ActionType from "./kosLocation.type";
import axios from "axios";
import { setToast } from "../../../util/toast";

export const getKosLocations =
	(query = "") =>
	(dispatch) => {
		apiInstanceFetch
			.get(`kosLocation${query ? "?" + query : ""}`)
			.then((res) => {
				dispatch({ type: ActionType.GET_KOS_LOCATIONS, payload: res.data || [] });
			})
			.catch((error) => console.log(error.message));
	};

export const syncKosLocations = () => (dispatch) => {
	axios.post(`kosLocation/sync`)
		.then((res) => {
			if (res.data.status) {
				setToast("success", res.data.message);
				// Re-fetch locations after sync
				dispatch(getKosLocations());
			} else {
				setToast("error", res.data.message);
			}
		})
		.catch((error) => console.log(error.message));
};

export const updateKosLocation = (locationId, data) => (dispatch) => {
	axios.patch(`kosLocation/update?locationId=${locationId}`, data)
		.then((res) => {
			if (res.data.status) {
				dispatch({ type: ActionType.UPDATE_KOS_LOCATION, payload: res.data.data });
				setToast("success", "Location updated");
			} else {
				setToast("error", res.data.message);
			}
		})
		.catch((error) => console.log(error.message));
};

export const bulkUpdateKosZone = (locationIds, zone) => (dispatch) => {
	axios.patch(`kosLocation/bulkZone`, { locationIds, zone })
		.then((res) => {
			if (res.data.status) {
				setToast("success", res.data.message);
				dispatch(getKosLocations());
			} else {
				setToast("error", res.data.message);
			}
		})
		.catch((error) => console.log(error.message));
};

export const getKosStates = () => (dispatch) => {
	apiInstanceFetch
		.get(`kosLocation/states`)
		.then((res) => {
			dispatch({ type: ActionType.GET_KOS_STATES, payload: res.data || [] });
		})
		.catch((error) => console.log(error.message));
};

export const getKosLgas =
	(state = "") =>
	(dispatch) => {
		apiInstanceFetch
			.get(`kosLocation/lgas${state ? "?state=" + encodeURIComponent(state) : ""}`)
			.then((res) => {
				dispatch({ type: ActionType.GET_KOS_LGAS, payload: res.data || [] });
			})
			.catch((error) => console.log(error.message));
	};
